module.exports = {"TXTWCL_Today":{"id":"TXTWCL_Today","defaultMessage":"Today"},"TXTWCL_Tomorrow":{"id":"TXTWCL_Tomorrow","defaultMessage":"Tomorrow"}}